export class GetPost {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  async execute({ postId }) {
    if (!postId) {
      return {
        success: false,
        error: 'Missing required parameters'
      };
    }

    try {
      const post = await this.postRepository.getPostById(postId);
      return {
        success: true,
        data: post
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
} 